import { Pipe, PipeTransform } from '@angular/core';
import { formatInvoiceNumber, Invoice } from '@shared';

@Pipe({
  name: 'invoicenumber',
})
export class InvoiceNumberPipe implements PipeTransform {
  transform(invoice: Invoice): string {
    if (!invoice) {
      return '';
    }

    const res_deleted =
      invoice?.reservation === null || invoice?.reservation === undefined;

    const invoice_type = invoice.type === 'invoice' ? 'R' : 'S';
    const invoice_prefix = `${invoice_type}${invoice?.reservation?.festival?.invoice_sequence?.prefix}`;
    const invoice_nr =
      invoice?.invoice_number !== undefined
        ? formatInvoiceNumber(invoice.invoice_number)
        : '';

    return res_deleted
      ? `....${invoice_nr} (Reservierung gelöscht)`
      : `${invoice_prefix}${invoice_nr}`;
  }
}
